import { css } from '@emotion/react';

export const Primary = `'Econ Sans', sans-serif`;

export const PrimaryProps = css`
  font-family: 'Econ Sans', sans-serif;
`;

export const Secondary = `'GTZirkon', sans-serif`;

export const SecondaryProps = css`
  font-family: 'GTZirkon', sans-serif;
`;

export const BasicFontForEconomistComponentsQ = css`
  font-family: 'EconSansOS', sans-serif;
`;

export const BasicFontForEconomistComponents = `'EconSansOS', sans-serif`;

const fontBaseSize = 16;
export const p2r = (v) => `${v / fontBaseSize}rem`;
